export enum QuestionnaireActionCode {
  // Pathology
  ServiceRequestCreate = 'questionnaire.action.servicerequest.create',
  // Appointments
  AppointmentCreate = 'questionnaire.action.appointment.create',
  // Task
  TaskCreate = 'questionnaire.action.task.create',
}
